export function filterByText(arr, text, fields) {
  if (!arr) {
    return [];
  }

  if (!text || !fields || fields.length === 0) {
    return arr;
  }

  const parts = text.toLowerCase().split(" ");

  return arr.filter((item) => {
    return parts.every((part) => {
      return fields.some((field) => {
        let value = item[field];
        if (!value) {
          return false;
        }
        if (typeof value !== "string") {
          value = value.toString();
        }
        return value.toLowerCase().includes(part);
      });
    });
  });
}
